import type { CellContext } from '@tanstack/react-table'

import type { Project } from '@/modules/projects'

export const NumberOfPagesCell = (cell: CellContext<Project, string>) => (
  <div className="text-left">{cell.getValue()}</div>
)
